<template>
  <div class="footer-pc">
    <div class="footer-box">
      <div class="footer-top">
        <div class="footer-top-left">
          <div>联系我们</div>
          <div>邮箱：2900430621@qq.com</div>
          <div>电话：15538285018</div>
        </div>
        <div class="footer-top-right">
          <div class="footer-ewm">
            <img src="@/assets/images/ewm-dingyuehao.png" alt="">
            <p>微信订阅号</p>
          </div>
          <div class="footer-ewm">
            <img src="@/assets/images/ewm-download.png" alt="">
            <p>APP下载</p>
          </div>
          <div class="footer-ewm">
            <img src="@/assets/images/ewm-kefu.png" alt="">
            <p>微信客服</p>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p>Copyright © 北京嘉彩科讯科贸有限公司
          <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备B2-2023189</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer-pc'
}
</script>

<style lang="scss" scoped>
.footer-pc {
  width: 100%;
  height: 396px;
  background-color: #192333;
  color: #FFFFFF;
  padding: 81px 0 40px;
  @include flex(row, center);

  .footer-box {
    width: $container-width;
    @include flex(col, space-between);

    .footer-top {
      @include flex(row, space-between, center);
      padding: 0 65px 54px;
      border-bottom: 1px solid #414C5F;

      .footer-top-left {
        flex: 1;

        div {
          font-size: 15px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 38px;

          &:nth-child(1) {
            font-size: 20px;
            line-height: 51px;
          }
        }
      }

      .footer-top-right {
        flex: 1;
        @include flex(row, center, center);

        .footer-ewm {
          @include flex(col, center, center);
          margin-right: 45px;

          img {
            width: 110px;
            height: 110px;
            border-radius: 5px;
            margin-bottom: 15px;
          }

          p {
            font-size: 16px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 40px;
          }
        }
      }
    }

    .footer-bottom {
      margin-top: 29px;
      text-align: center;

      p, a {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #7D7D7D;
        line-height: 40px;
      }
    }
  }
}
</style>
